import { useBreakpointValue } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useSampleDataContext } from '@resistapp/client/contexts/sample-data-context';
import { QueryFilters } from '@resistapp/client/hooks/use-query-filters/use-query-filters';
import { getShortNormalisationLabel } from '@resistapp/common/normalisation-mode';
import { NormalisationMode } from '@resistapp/common/types';
import { FilterBarResistomapSelect as ResistomapSelect } from '../../forms/filter-bar-resistomap-select';

export type Props = { queryFilters: QueryFilters; compact?: boolean };

type NormalisationOption = {
  label: string;
  value: NormalisationMode;
};

export function NormalisationModeSelector({ queryFilters, compact = false }: Props) {
  const { availableNormalisationModes } = useSampleDataContext();
  const screenSize = useBreakpointValue({ base: 'base', md: 'md', lg: 'lg', lg2: 'lg2', xl: 'xl' });
  const isWideScreen = screenSize === 'xl' || screenSize === 'lg2' || screenSize === 'md';
  const isWide = compact ? false : isWideScreen;

  // Create options for the dropdown
  const options = availableNormalisationModes.map(mode => ({
    label: getShortNormalisationLabel(mode, isWide),
    value: mode,
  }));

  // Find the currently selected option
  const selectedOption = options.find(option => option.value === queryFilters.filters.normalisationMode) || options[0];

  return (
    <Container>
      <ResistomapSelect<NormalisationOption, false>
        options={options}
        value={selectedOption}
        onChange={option => {
          if (option?.value) {
            queryFilters.setNormalisationModeStable(option.value);
          }
        }}
        size="md"
      />
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
`;
